import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

import Project from "./project";

import INFO from "../../data/user";

import "./styles/allProjects.css";


const AllProjects = ({ featuredOnly = false }) => {
	const [activeCategory, setActiveCategory] = useState("All");
	const sourceProjects = featuredOnly ? INFO.projects.slice(0, 5) : INFO.projects;
	const categories = useMemo(
		() => ["All", ...new Set(sourceProjects.flatMap((project) => project.categories || []))],
		[sourceProjects]
	);
	const projects = sourceProjects.filter(
		(project) => activeCategory === "All" || (project.categories || []).includes(activeCategory)
	);
	return (
		<>
			<div className="projects-heading-row">
				<div>
					<p className="eyebrow">SELECTED WORK</p>
					<h3 className="all-projects-title">Products, platforms, and systems</h3>
				</div>
				{!featuredOnly && <span className="projects-count">{projects.length} projects</span>}
			</div>
			{!featuredOnly && <div className="project-filters" aria-label="Project categories">
				{categories.map((category) => (
					<button className={activeCategory === category ? "filter active" : "filter"} key={category} onClick={() => setActiveCategory(category)}>
						{category}
					</button>
				))}
			</div>}
			<div className="all-projects-container">
				{projects.map((project, index) => (
					<div className="all-projects-project" key={index}>
						<Project
							logo={project.logo}
							title={project.title}
							description={project.description}
							linkText={project.linkText}
							link={project.link}
							tags={project.tags}
							imageFit={project.imageFit}
						/>
					</div>
				))}
			</div>
			<div className="more-links">
				{featuredOnly ? <Link to="/projects">Explore all projects</Link> : <a href="https://github.com/EmmanuelMmanda" rel="noreferrer" target="_blank">More Projects on GitHub</a>}
			</div>
		</>
	);
};

export default AllProjects;
